import { Box, Button, Divider } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SaveIcon from '@mui/icons-material/Save';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import CodeIcon from '@mui/icons-material/Code';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import SendIcon from '@mui/icons-material/Send';
import { filledButtonSx, outlinedButtonSx, toolbarSx } from '../shared/buttonStyles';
import type { EmailEditorMode } from '../../EmailUnlayerSection';

interface EmailEditorToolbarProps {
  mode: EmailEditorMode;
  ready: boolean;
  hasHtmlContent: boolean;
  saved: boolean;
  onInsertCode: () => void;
  onInsertField: () => void;
  onPreview: () => void;
  onBat: () => void;
  onSave: () => void;
  onToggleMode: () => void;
}

function EmailEditorToolbar({
  mode, ready, hasHtmlContent, saved,
  onInsertCode, onInsertField, onPreview, onBat, onSave, onToggleMode,
}: EmailEditorToolbarProps) {
  const isHtml = mode === 'html';
  const insertDisabled = !isHtml && !ready;
  const exportDisabled = isHtml ? !hasHtmlContent : !ready;
  const saveColor = saved ? 'success.main' : 'primary.main';

  return (
    <Box sx={{ ...toolbarSx, mb: 2 }}>
      <Button variant="contained" size="small" startIcon={<QrCode2Icon fontSize="small" />}
        onClick={onInsertCode} sx={filledButtonSx()} disabled={insertDisabled}>
        Code opération
      </Button>
      <Button variant="contained" size="small" startIcon={<PersonAddAltIcon fontSize="small" />}
        onClick={onInsertField} sx={filledButtonSx()} disabled={insertDisabled}>
        Champ de personnalisation
      </Button>

      <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />

      <Button variant="outlined" size="small" startIcon={<VisibilityIcon fontSize="small" />}
        onClick={onPreview} disabled={exportDisabled} sx={outlinedButtonSx()}>
        Prévisualiser
      </Button>
      <Button variant="outlined" size="small" startIcon={<SendIcon fontSize="small" />}
        onClick={onBat} disabled={exportDisabled} sx={outlinedButtonSx()}>
        BAT
      </Button>
      <Button variant="contained" size="small"
        startIcon={saved ? <CheckCircleOutlineIcon fontSize="small" /> : <SaveIcon fontSize="small" />}
        onClick={onSave} disabled={!ready || isHtml}
        sx={{ textTransform: 'none', fontWeight: 600, fontSize: '0.82rem', backgroundColor: saveColor, '&:hover': { backgroundColor: saveColor, opacity: 0.9 } }}>
        {saved ? 'Sauvegardé !' : 'Sauvegarder'}
      </Button>

      <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />

      <Button
        variant="outlined"
        size="small"
        startIcon={isHtml ? <DashboardCustomizeIcon fontSize="small" /> : <CodeIcon fontSize="small" />}
        onClick={onToggleMode}
        disabled={!ready}
        sx={{ ...outlinedButtonSx(), fontWeight: 600 }}
      >
        {isHtml ? 'Builder visuel' : 'Vue HTML'}
      </Button>
    </Box>
  );
}

export default EmailEditorToolbar;
